import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ListItem\UpdateListItemController::__invoke
* @see app/Http/Controllers/ListItem/UpdateListItemController.php
* @route '/api/list-item/{list_item}'
*/
const UpdateListItemController = (args: { list_item: string | number | { id: string | number } } | [list_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateListItemController.url(args, options),
    method: 'put',
})

UpdateListItemController.definition = {
    methods: ["put"],
    url: '/api/list-item/{list_item}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ListItem\UpdateListItemController::__invoke
* @see app/Http/Controllers/ListItem/UpdateListItemController.php
* @route '/api/list-item/{list_item}'
*/
UpdateListItemController.url = (args: { list_item: string | number | { id: string | number } } | [list_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { list_item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { list_item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            list_item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        list_item: typeof args.list_item === 'object'
        ? args.list_item.id
        : args.list_item,
    }

    return UpdateListItemController.definition.url
            .replace('{list_item}', parsedArgs.list_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ListItem\UpdateListItemController::__invoke
* @see app/Http/Controllers/ListItem/UpdateListItemController.php
* @route '/api/list-item/{list_item}'
*/
UpdateListItemController.put = (args: { list_item: string | number | { id: string | number } } | [list_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateListItemController.url(args, options),
    method: 'put',
})

export default UpdateListItemController